const getCurrentPath = (pathname) => {
  if (pathname.lastIndexOf('/') > 0) {
    return pathname.split('/').slice(0, 2).join('/');
  }
  return pathname;
};

export default getCurrentPath;
